import { Pill } from '@domgen/base-design-system-2.0/atoms/Pill';
import { GiftIcon } from '../../../assets/icons/GiftIcon';

export type OfferPanelProps = {
  discountPercentage?: number;
  discountTerm?: number;
  show2MonthsPromotion?: boolean;
  netFirstPaymentAmount: number;
  netFirstPaymentAmountAfterPromotionalPeriod?: number;
  periodOfCover: number;
  discountPaymentType?: 'cc' | 'ach';
  brand: string;
};

const styles = {
  offerPanel:
    'flex flex-col items-center text-center gap-space-200 pb-space-400 pl-space-500 rounded-radius-200 w-full ',
};

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const OfferPanelA = ({
  periodOfCover,
  discountPercentage,
  discountTerm,
  show2MonthsPromotion,
  netFirstPaymentAmount,
  netFirstPaymentAmountAfterPromotionalPeriod,
  discountPaymentType,
  brand,
}: OfferPanelProps) => {
  const payment = (
    <h6 className="text-body-strong">
      {!!netFirstPaymentAmountAfterPromotionalPeriod &&
        !show2MonthsPromotion &&
        netFirstPaymentAmount < netFirstPaymentAmountAfterPromotionalPeriod && (
          <span className="line-through text-button-text-outline-disabled mr-2">
            {currencyFormatter.format(netFirstPaymentAmountAfterPromotionalPeriod)}
          </span>
        )}
      {currencyFormatter.format(netFirstPaymentAmount)} a month
    </h6>
  );

  const formatPillText = () => {
    const achMarker = discountPaymentType === 'ach' ? '*' : '';

    if (show2MonthsPromotion) {
      return "Our Lowest Price Ever is Back - Don't Miss Out!";
    }

    if (discountPercentage && discountTerm === periodOfCover) {
      return `${discountPercentage}% off${achMarker}`;
    }

    if (discountPercentage && discountTerm && discountTerm < periodOfCover) {
      return `${discountPercentage}% off for first ${discountTerm} months${achMarker}`;
    }

    return <>ONLINE OFFER</>;
  };

  return (
    <div className={styles.offerPanel}>
      <div className="flex flex-col w-full items-center gap-space-200 text-center md:text-right  md:items-end">
        <div>
          <Pill variant="successLight">
            <h6 className="flex justify-center flex-row items-baseline gap-space-100 text-body-small-strong">
              {formatPillText()}
              <span className="w-3 h-3">
                <GiftIcon size={12} />
              </span>
            </h6>
          </Pill>
        </div>
        <p className="text-body-strong ">Add {brand} Appliance Care: </p>
        {payment}
        <p className="text-body-large-strong text-success-600">
          Flexible monthly plan, cancel anytime.
        </p>
        <p className="text-body-small">
          Applicable taxes calculated during checkout.
          {discountPaymentType === 'ach' &&
            !show2MonthsPromotion &&
            ' *Discount applies to payments made via Bank Account only.'}
        </p>
      </div>
    </div>
  );
};
